jQuery(function () {
    $(window).on('load', function () {
        if ($('body').hasClass('demo-account')) {
            var buttonsToBlur = $('body').find('.demo-account-blurred-btn');
            buttonsToBlur.attr('href', 'javascript:void(0)');
        }
    });
});
